import React, { useState } from "react";

import { CssBaseline, Typography } from "@mui/material";

import WeatherDate from "./components/Date/WeatherDate";
import NewWeather from "./components/Search/NewWeather";
import WeatherWidget from "./components/Widget/WeatherWidget";

const DUMMY = [];

const App = () => {
  const [weathers, setWeather] = useState(DUMMY);

  const addWeatherHandler = (weather) => {
    setWeather((prevWeathers) => {
      return [weather, ...prevWeathers];
    });
  };

  return (
    <>
    <CssBaseline>
      <Typography align="center">WEATHER APPLICATION</Typography>
      <WeatherDate />
      <NewWeather onAddWeather={addWeatherHandler} />
      {weathers.length !== 0 && <WeatherWidget items={weathers} />}
    </CssBaseline>
    </>
  );
};

export default App;
